import { getConfig } from '@/tools/config'

const getBaseUrl = () => `${getConfig().appUrl}/next`

export const executeReorder = (orderUrn: string) => {
  if (!getConfig().isBrowser) {
    return
  }
  window.location.href = `${getBaseUrl()}/reorder/?orderUrn=${orderUrn}`
  return
}

export const getLegacyStoreLink = (storeSlug: string) => {
  if (!getConfig().isBrowser) {
    return
  }
  return `${getBaseUrl()}/open-store/?storeSlug=${storeSlug}`
}

export const getTokenisationLink = (method?: string) => {
  if (!getConfig().isBrowser) {
    return
  }
  return `${getBaseUrl()}/tokenise-pm/${method ? `?method=${method}` : ''}`
}

export const redirectToCityPage = async () => {
  const url = `${getBaseUrl()}/city-page`
  if (getConfig().isBrowser) {
    window.location.href = url
  } else {
    // @ts-expect-error: Somehow Ts complains because cannot find 'next/navigation'
    const { redirect } = await import('next/navigation')
    redirect(url)
  }
}

export const executePackageDelivery = () => {
  if (!getConfig().isBrowser) {
    return
  }
  window.location.href = `${getBaseUrl()}/courier-delivery`
}
